import { NgModule,} from '@angular/core';
import {IonicModule, IonicPageModule} from "ionic-angular";
import {SellionsLayoutRendererLibModule} from "../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/sellions-layout-renderer-lib.module";
import {GenericDataViewService} from "../generic-data-view.service";
import {ComponentsModule} from "../../shared/components/components.module";
import {GenericDataViewDetailsPage} from "./generic-data-view-details.page";
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [GenericDataViewDetailsPage],
  imports: [
    IonicPageModule.forChild(GenericDataViewDetailsPage),
    SellionsLayoutRendererLibModule,
    IonicModule,
    ComponentsModule,
    MatButtonModule,
  ],
  entryComponents: [GenericDataViewDetailsPage],
  providers: [GenericDataViewService],
  exports: [GenericDataViewDetailsPage]
})
export class GenericDataViewDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/generic-data-view/generic-data-view-details/generic-data-view-details.page.module.ts